<button
  [type]="type()"
  [disabled]="disabled()"
  [class]="classes()"
  [attr.aria-haspopup]="haspopup()"
  [attr.aria-expanded]="expanded()"
  (click)="handleClick($event)"
>
  @if (leadingIcon(); as icon) {
    <esn-icon [name]="icon" [size]="16" />
  }
  <ng-content />
  @if (trailingIcon(); as icon) {
    <esn-icon [name]="icon" [size]="16" />
  }
</button>
